import { Component, OnInit } from '@angular/core';

import { DataService } from 'src/app/dataService/dataService.service';
import { FormGroup, FormArray, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { interfaces } from '@leandredev/adaptivai-common-lib';
import { ApiHelper } from '@leandredev/common-ng16/httpClient';
import { BaseComponent } from '@leandredev/common-ng16/infraService';

import { form } from '@leandredev/adaptivai-ng16-lib';
import { CommonModule } from '@angular/common';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { UserClientInvitationFormModule } from 'src/app/generated/ui/form/UserClientInvitation/UserClientInvitation.module';
@Component({
  selector: 'app-user-client-new',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FurySharedModule, FuryCardModule, UserClientInvitationFormModule],
  templateUrl: './user-client-new.component.html',
  styleUrls: ['./user-client-new.component.scss']
})
export class UserClientNewComponent extends BaseComponent implements OnInit {
  public userRoles: interfaces.IUserRole[] = [];
  public currentEditName = '';
  public userClientGroups: interfaces.IUserClientGroup[] = [];
  public gap = 'px';
  public invitationsResult: interfaces.IUserClientInvitationResponse;
  public allUserFormGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dataService: DataService
  ) {
    super();
    this.allUserFormGroup = this.fb.group({ users: this.fb.array([]), name: 'users' });
  }

  ngOnInit(): void {
    this.subscription.add(
      this.dataService.api.collections.UserClientGroup.get()
        .pipe(ApiHelper.resultToArr('Error fetching user client groups'))
        .subscribe((groups) => {
          this.userClientGroups = groups;
        })
    );

    this.subscription.add(
      this.dataService.api.collections.UserRole.get('*/activatedToNewUser/true/=/')
        .pipe(ApiHelper.resultToArr('Error fetching user roles'))
        .subscribe((roles) => {
          this.userRoles = roles;
        })
    );
  }

  public save(): void {
    // Refaire l'interface avec la bonne orthographe Request et non Resquest
    const invitations: interfaces.IUserClientInvitationResquest = { invitations: [] };

    if (this.users?.value) {
      invitations.invitations = this.users.value as interfaces.IUserClientInvitation[];
      this.dataService.admin
        .invitations(invitations, {}, {})
        .pipe(ApiHelper.resultToObj(''))
        .subscribe({
          next: (result) => {
            this.setInvitationsResponse(result);
          }
        });
    }
  }

  public get users(): FormArray {
    return this.allUserFormGroup.get('users') as FormArray;
  }

  public newUser(): FormGroup {
    const defaultUserGroup = [] as string[];

    this.userClientGroups.forEach((group) => {
      if (group.activatedToNewUser) {
        defaultUserGroup.push(String(group._id));
      }
    });

    const roles: string[] = this.userRoles.map((role) => String(role._id));
    const userForm = new form.UserClientInvitation();
    userForm.patchValue({ createdAt: new Date(), roles: roles, userClientGroup: defaultUserGroup });
    return userForm;
  }

  public addUser(): void {
    this.users.push(this.newUser());
  }

  public removeUser(i: number): void {
    this.users.removeAt(i);
  }

  protected setInvitationsResponse(data: interfaces.IUserClientInvitationResponse): void {
    this.users.clear();
    this.invitationsResult = data;
  }
}
